import React from 'react'
import { Button } from 'beautiful-react-ui';
import '../../styles/SpecialRender.scss';
import DiagramIDE from '../../ide/DiagramIDE';
import { RenderProps } from './RenderProps';
import { RenderHelper } from './RenderHelper';

export function IfRender(props: RenderProps) {
    let inpDivs = props.inputs ? RenderHelper.makeInputDivs(props.inputs, props.data.inputNames) : [];

    function trueButton() {
        console.log("Clicked True button! (going to if schema)");
        DiagramIDE.getIDE().setDisplaySchemaId(`${props.id}if`);
    }

    function falseButton() {
        console.log("Clicked False button! (going to else schema)");
        DiagramIDE.getIDE().setDisplaySchemaId(`${props.id}else`);
    }

    return (
        <div>
            <div className="if-node" >
                <div className="deleteBtn">
                    <Button icon="times" size="small" onClick={() => RenderHelper.deleteNode(props.data.parentSchema, props.id)} />
                </div>

                <div className="ports">
                    <div className="inputs">
                        {inpDivs}
                    </div>
                    <div className="content">
                        {props.content}
                    </div>
                </div>
                <div className="buttons">
                    <button className="true-btn" onClick={trueButton}>True</button>
                    <button className="false-btn" onClick={falseButton}>False</button>
                </div>
            </div>
        </div>
    )
}

